module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<svg viewBox="0 0 90 90"\n     class="text-icon"\n     version="1.1"\n     xmlns="http://www.w3.org/2000/svg">\n\n    <path fill="#FFFFFF"\n          d="M45 0C20.15 0 0 20.15 0 45s20.15 45 45 45 45-20.15 45-45S69.85 0 45 0z"></path>\n    <path fill="<%- fillcolor %>"\n          d="M45 1.38c24.05 0 43.62 19.57 43.62 43.62S69.05 88.62 45 88.62 1.38 69.05 1.38 45 20.95 1.38 45 1.38M45 0C20.15 0 0 20.15 0 45s20.15 45 45 45 45-20.15 45-45S69.85 0 45 0z"></path>\n\n    <text x="45"\n          y="60"\n          font-family="Arial"\n          font-weight="bold"\n          font-size="40"\n          text-anchor="middle"\n          fill="<%- fillcolor %>"><%= letters %></text>\n</svg>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<svg viewBox="0 0 90 90"\n     class="text-icon"\n     version="1.1"\n     xmlns="http://www.w3.org/2000/svg">\n\n    <path fill="#FFFFFF"\n          d="M45 0C20.15 0 0 20.15 0 45s20.15 45 45 45 45-20.15 45-45S69.85 0 45 0z"></path>\n    <path fill="', (__stack.lineno = 8, fillcolor), '"\n          d="M45 1.38c24.05 0 43.62 19.57 43.62 43.62S69.05 88.62 45 88.62 1.38 69.05 1.38 45 20.95 1.38 45 1.38M45 0C20.15 0 0 20.15 0 45s20.15 45 45 45 45-20.15 45-45S69.85 0 45 0z"></path>\n\n    <text x="45"\n          y="60"\n          font-family="Arial"\n          font-weight="bold"\n          font-size="40"\n          text-anchor="middle"\n          fill="', (__stack.lineno = 17, fillcolor), '">', escape((__stack.lineno = 17, letters)), "</text>\n</svg>\n");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/templates/global-menu-generic-icon.ejs
// module id = 250
// module chunks = 0 1